import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription, of } from 'rxjs';
import { StorageService } from 'src/app/service/storage/storage.service';
import { LogoutService } from 'src/app/service/user/logout.service';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../asm/asm-constant';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LinkComponent implements OnInit, AfterViewChecked, OnDestroy {
  deviceInfo: any = null;
  data$: Observable<any> = this.component.data$;
  styleClass: string;
  hasEditPreferenceDiscountBtns: boolean;
  componentDataSub$: Subscription;
  componentData$: any;

  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);

  constructor(
    public component: CmsComponentData<CmsLinkComponent>,
    private deviceService: DeviceDetectorService,
    private cdr: ChangeDetectorRef,
    private logoutService: LogoutService,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.componentDataSub$ = this.data$.subscribe((data) => {
      if (data !== null) {
        this.componentData$ = of(data);
        const updateStyleClass = data.styleClass;
        if (this.deviceInfo.browser.toLowerCase() === 'chrome') {
          if (typeof updateStyleClass !== 'undefined') {
            if (updateStyleClass.includes('primary-btn-safari')) {
              this.styleClass = 'button primary-btn';
            } else if (updateStyleClass.includes('secondary-btn-safari')) {
              this.styleClass = 'button secondary-btn';
            } else {
              this.styleClass = data.styleClass;
            }
          }
        } else {
          this.styleClass = data.styleClass;
        }
        this.cdr.detectChanges();
      }
    });
  }

  ngAfterViewChecked() {
    const hasEditPreference = document.querySelector('.myaccount-edit-preferences');
    const hasDiscount = document.querySelector('.myaccount-discounts');
    this.hasEditPreferenceDiscountBtns = hasEditPreference === null && hasDiscount === null ? false : true;
    if (this.hasEditPreferenceDiscountBtns) {
      if (hasEditPreference === null) {
        if (hasDiscount !== null) {
          hasDiscount.classList.add('right');
        }
      } else {
        if (hasDiscount !== null) {
          hasDiscount.classList.remove('right');
        }
      }
    }
  }

  handleClick(url: string, event: MouseEvent) {
    event.preventDefault();
    if (url.includes('/logout')) {
      this.logoutService.logout();
    } else if (url.includes('/login?asm=false')) {
      this.storageService.clearLocalStorageItem();
      const url = new URL(window.location.href);
      url.searchParams.set('asm', 'false');
      window.location.href = url.toString();
    } else {
      return true;
    }
  }
  getClass(styleClass: string | undefined, url: string) {
    return {
      ...(styleClass ? { [styleClass]: true } : {}),
      'd-none': !this.asmEnabled && url?.includes('/login?asm=false'),
    };
  }

  ngOnDestroy(): void {
    if (this.componentDataSub$) {
      this.componentDataSub$.unsubscribe();
    }
  }
}
